// Dates are stored and sent as ISO 8601 (UTC) and only formatted for display,
// always DD/MM/YYYY in UK time.

const TZ = 'Europe/London';

const dateFmt = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric' });
const timeFmt = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });

function toDate(value) {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDate(value) {
  const d = toDate(value);
  return d ? dateFmt.format(d) : '';
}

// Today's date in the UK as YYYY-MM-DD, for date-only fields (team moves,
// bookings). en-CA formats as ISO.
const isoDayFmt = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });
export function todayUk(now = new Date()) {
  return isoDayFmt.format(now);
}

// A YYYY-MM-DD date-only value as DD/MM/YYYY, without passing through a
// timezone (new Date('2026-10-15') is UTC midnight and can show the day before).
export function formatDay(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
}

export function formatDateTime(value) {
  const d = toDate(value);
  return d ? `${dateFmt.format(d)} ${timeFmt.format(d)}` : '';
}
